import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.notice.item');
import { OnInit, Input, DoCheck, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import showdown from 'showdown';

@Component({
    selector: 'wiz-portal-gsdcuser-notice-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.notice.item/view.scss */
/* src/app/portal.gsdcuser.notice.item/view.scss: no such file or directory */`],
})
export class PortalGsdcuserNoticeItemComponent implements OnInit, DoCheck, OnDestroy {
    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    @Input() notice_id: any;

    public info: any;
    public comments: any = [];
    public newComment: string = '';
    public commentPage = 1;
    public commentPages = 0;
    public commentTotal = 0;
    public commentLoading = false;
    private ready = false;
    private lastNotice: string;
    private requestVersion = 0;

    public async ngDoCheck() {
        if (this.ready) await this.checkNotice();
    }

    public async ngOnInit() {
        await this.service.init();
        this.ready = true;
        await this.checkNotice();
    }

    public ngOnDestroy() { this.ready = false; this.requestVersion++; }

    private async checkNotice() {
        const id = WizRoute.segment.item || this.notice_id;
        if (!id || id === this.lastNotice) return;
        this.lastNotice = this.notice_id = id;
        this.newComment = '';
        this.info = undefined;
        await this.load(1);
    }

    public async load(page = this.commentPage) {
        const version = ++this.requestVersion;
        this.commentLoading = true;
        try {
            const { code, data } = await wiz.call('load', { notice_id: this.notice_id, comment_page: page });
            if (version !== this.requestVersion) return false;
            if (code != 200) {
                if (!this.info) { window.location = '/dashboard'; return false; }
                await this.service.alert.error('Error!');
                return false;
            }
            this.info = data.info;
            this.info.extra = JSON.parse(this.info.extra);
            this.comments = data.comments;
            this.commentTotal = data.comment_total;
            this.commentPage = data.comment_page;
            this.commentPages = data.comment_pages;
            await this.service.render();
            return true;
        } catch (_) {
            if (version === this.requestVersion) await this.service.alert.error('Error!');
            return false;
        } finally {
            if (version === this.requestVersion) {
                this.commentLoading = false;
                await this.service.render();
            }
        }
    }

    public get commentPageNumbers(): number[] {
        const start = Math.max(1, Math.min(this.commentPage - 2, this.commentPages - 4));
        return Array.from({ length: Math.min(5, this.commentPages) }, (_, index) => start + index);
    }

    private focusComments() {
        const heading = document.getElementById('notice-comments-title');
        heading?.focus({ preventScroll: true });
        heading?.scrollIntoView({ block: 'start', behavior: 'auto' });
    }

    public async moveComments(page: number) {
        if (this.commentLoading || page < 1 || page > this.commentPages || page === this.commentPage) return;
        if (await this.load(page)) this.focusComments();
    }

    public showdown(text) {
        const markdown = typeof text === 'string' ? text : '';
        let converter = new showdown.Converter();
        return converter.makeHtml(markdown);
    }

    public async commentWrite(comment: any) {
        if (!comment) return await this.service.alert.warning("댓글을 작성해주세요.");
        this.newComment = comment;
        const { code, data } = await wiz.call("commentWrite", { notice_id: this.notice_id, comment: this.newComment });
        if (code != 200) return await this.service.alert.error("Error!");
        this.newComment = "";
        if (await this.load(1)) this.focusComments();
    }

    public async removeComment(comment) {
        let res = await this.service.alert.error("댓글을 삭제하시겠습니까?", "닫기", "삭제");
        if (!res) return;
        const { code } = await wiz.call("remove_comment", comment);
        if (code != 200) return await this.service.alert.error("Error!");
        if (await this.load()) this.focusComments();
    }
}

export default PortalGsdcuserNoticeItemComponent;